<template>
  <div v-if="states != null">
    <div class="label-standard">State</div>

    <div class="mt-2">
      <select
        :value="value != null ? value : -1"
        :disabled="disabled"
        v-on:change="updateValue({
          objectType: objectType,
          key       : propertyKey, 
          value     : $event.target.value,
          index     : index
        })"
        class="select-standard">
        <option value="-1" disabled="">Select an option...</option>
        <template v-for="(state, index) in states">
          <option :value="state.id">{{ state.name }}</option>
        </template>
      </select>
    </div>
  </div>
</template>

<script>
  export default {
    props : {
      objectType : {
        type    : String,
        required: false
      },

      value : {
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      disabled : {
        type : Boolean,
        required : false,
        default : false
      }
    },

    data() {
      return {
        states : null
      }
    },

    created() {
      this.apiGet({}, 'common/states', (states) => {
        this.states = states
      })
    }
  }
</script>